<template>
  <section>
    <!-- Account Number -->
    <q-field
      :label="!hideLabel ? $t('bank_details') : ''"
      :labelWidth="2"
      :icon="showIcon ? 'account_balance' : undefined"
      :error="errors.has('accountNumber_' +  id)"
      :error-label="errors.first('accountNumber_' + id)"
    >
      <q-input
        v-model="bankDetails.accountNumber"
        v-validate.disable="'iban|max:255'"
        :name="'accountNumber_' + id"
        :data-vv-as="$t('account_number')"
        :placeholder="$t('account_number')"/>
    </q-field>

    <template v-if="bankDetails.accountNumber || expanded">
      <q-field :inset="inset" :labelWidth="2">
        <div class="row gutter-sm">
          <!-- Account Owner -->
          <div class="col-sm-4 col-12 q-mb-sm">
            <q-field
              class="no-margin"
              :error="errors.has('accountOwner_' + id)"
              :error-label="errors.first('accountOwner_' + id)"
            >
              <q-input
                v-model="bankDetails.accountOwner"
                v-validate.disable="'max:255'"
                :name="'accountOwner_' + id"
                :data-vv-as="$t('account_owner')"
                :placeholder="$t('account_owner')"/>
            </q-field>
          </div>

          <!-- Bank Name -->
          <div class="col-sm-4 col-12 q-mb-sm">
            <q-field
              class="no-margin"
              :error="errors.has('bankName_' + id)"
              :error-label="errors.first('bankName_' + id)"
            >
              <q-input
                v-model="bankDetails.bankName"
                v-validate.disable="'max:255'"
                :name="'bankName_' + id"
                :data-vv-as="$t('bank_name')"
                :placeholder="$t('bank_name')"/>
            </q-field>
          </div>

          <!-- Bank Identifier -->
          <div class="col-sm-4 col-12 q-mb-sm">
            <q-field
              class="no-margin"
              :error="errors.has('bankIdentifier_' +  id)"
              :error-label="errors.first('bankIdentifier_' + id)"
            >
              <q-input
                v-model="bankDetails.bankIdentifier"
                v-validate.disable="'max:255'"
                :name="'bankIdentifier_' + id"
                :data-vv-as="$t('bank_identifier')"
                :placeholder="$t('bank_identifier')"/>
            </q-field>
          </div>
        </div>
      </q-field>

      <!-- Bank Details Label -->
      <q-field
        v-show="bankDetails.accountNumber && label"
        :inset="inset"
        :labelWidth="2"
        :error="errors.has('bankDetailsLabel_' + id)"
        :error-label="errors.first('bankDetailsLabel_' + id)"
      >
        <q-input
          v-model="bankDetails.label"
          v-validate.disable="'max:255'"
          :name="'bankDetailsLabel_' + id"
          :data-vv-as="$t('label')"
          :placeholder="$t('label')"/>
      </q-field>
    </template>
  </section>
</template>

<script>
  export default {
    inject: ['$validator'],

    props: {
      /**
       * Used for v-model
       */
      value: {
        type: [Object],
        required: true
      },

      /**
       * Id of the input. Required for multiple address inputs per page
       */
      id: {
        type: Number,
        default: 0
      },

      /**
       * Indicate if the input should be expanded by default
       */
      expanded: {
        type: Boolean,
        default: false
      },

      /**
       * Indicate if the label input should be visible
       */
      label: {
        type: Boolean,
        default: false
      },

      /**
       * Indicate if the label of the address line field should be visible
       */
      hideLabel: {
        type: Boolean,
        default: false
      },

      /**
       * Indicate if the field icon should be visibile
       */
      showIcon: {
        type: Boolean,
        default: false
      }
    },

    data () {
      return {
        bankDetails: this.value
      }
    },

    computed: {
      inset () {
        if (this.showIcon && !this.hideLabel) {
          return 'all'
        }

        return this.showIcon ? 'icon' : !this.hideLabel ? 'label' : null
      }
    },

    watch: {
      value: {
        handler: function (newBankDetails) {
          this.bankDetails = newBankDetails
        },
        deep: true
      },

      bankDetails: {
        handler: function (newBankDetails) {
          this.$emit('input', newBankDetails)
        },
        deep: true
      }
    }
  }
</script>
